module.exports = __webpack_public_path__ + "img/2012-1.68754daa.jpeg";